import React from "react";
import GameModuleFrame from "../../game-platform/GameModuleFrame";

export const onlineCapabilities = Object.freeze({
  map: false,
  location: false,
  timedQuestions: true,
  physicalItems: false,
});

const onlineDefaults = Object.freeze({
  backgroundColor: "#090D14",
  surfaceColor: "#111827",
  textColor: "#F4F7FB",
  accentColor: "#8FB8E8",
  textureOpacity: 0.2,
});

export default function OnlineGameApp(props) {
  return (
    <GameModuleFrame
      {...props}
      moduleId="online"
      defaults={onlineDefaults}
      capabilities={onlineCapabilities}
    />
  );
}
